var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"deal-modal",attrs:{"title":_vm.title,"visible":_vm.visible,"close-on-click-modal":false,"append-to-body":"","before-close":_vm.handleClose,"width":_vm.diaWidth + 'px'},on:{"open":_vm.init}},[_c('el-divider'),_c('div',[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }